import { render, staticRenderFns } from "./card-resumo-propostas.vue?vue&type=template&id=491ae4ad&scoped=true"
import script from "./card-resumo-propostas.vue?vue&type=script&lang=js"
export * from "./card-resumo-propostas.vue?vue&type=script&lang=js"
import style0 from "./card-resumo-propostas.vue?vue&type=style&index=0&id=491ae4ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491ae4ad",
  null
  
)

export default component.exports